import { Component } from '@angular/core';
import { ResearchCvParseEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Cv Parses') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-researchcvparse-form',
    templateUrl: './researchcvparse.form.component.html'
})
export class ResearchCvParseFormComponent extends BaseFormComponent {
    public record!: ResearchCvParseEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'cvTags', sectionName: 'Cv Tags', isExpanded: false }
        ]);
    }
}

